module.exports = __webpack_public_path__ + "media/images/twitter-b9518ed780727a7250926068ea3b238a.png";